export function  getCodigoId(operationType: string, id: number) {
    let paddedId = id.toString().padStart(7, "0");

    if (operationType === "financiacion") return "F" + paddedId;
    if (operationType === "bnpl") return "B" + paddedId;

    return "C" + paddedId;
  }